module.exports = __webpack_public_path__ + "img/like.e9ae977d.svg";